<template>
    <div>
        <div v-show="cards && (showGooglepay || showApplepay)">
            <div class="card-body border-top pb-3">
                <div class="row align-items-center">
                    <div class="col pt-2" v-show="showGooglepay">
                        <div ref="googlepay-container"></div>
                    </div>
                    <div class="col" v-show="showApplepay">
                        <div ref="applepay-container"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body pt-0" v-show="cards">
            <div ref="card-container" id="card-container"></div>
            <div class="form-group mt-2" v-if="requirePostalCode">
                <label class="d-block">{{ $t("payment_method.form.postal_code") }}</label>
                <input type="text" class="form-control" v-model="postalcode" v-on:keyup="updatePaymentData()" placeholder="91351">
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import merge from "lodash/merge";

    export default {
        name: "FieldsAdyen",
        data() {
            return {
                loaded: false,
                brand: '',
                currency: null,
                bin : '',
                postalcode : '',
                state: null,
                cards: true,
                showGooglepay: false,
                showApplepay: false,
                adyenCheckout: null,
                googlePayComponent: null,
                applePayComponent: null,
            }
        },
        methods: {
            handleCardOnChange: function (state, component) {
                this.state = state;

                this.updatePaymentData();
            },
            updatePaymentData: function () {
                let data = this.state.data;
                let state = this.state;

                data.brand = this.brand;
                data.postalcode = this.postalcode;
                data.browserInfo = window.ThreedDS2Utils.getBrowserInfo();

                if (window.tebex.methods.adyen.disallowedBins.includes(this.bin)) {
                    data.error = this.$t("payment_method.messages.card_not_accepted");
                    this.$store.commit('setPaymentMethodData',
                        {
                            valid: false,
                            data: data,
                            brand : this.brand
                        }
                    )
                    return;
                }

                if (data.postalcode === '') {
                    data.error = this.$t("payment_method.messages.postal_code_not_provided");
                    this.$store.commit('setPaymentMethodData',
                        {
                            valid: false,
                            data: data,
                            brand : this.brand
                        }
                    )
                    return;
                }

                data.error = null;
                data.bin = this.bin;

                this.$store.commit('setPaymentMethodData',
                    {
                        valid: state.isValid,
                        data: data,
                        brand : this.brand
                    }
                )
            },
            handleOnBrand: function (brand, component) {
                this.brand = brand.brand;

                if (!this.currency) {
                    this.currency = this.selectedMethod.currency;
                }

                this.$store.commit('setPaymentMethod', {
                    ...this.selectedMethod,
                    currency: this.currency
                });
            },
            mountApplePay() {
                this.showApplepay = false;

                if (this.applePayComponent) {
                    this.applePayComponent.unmount();
                }

                const amount = {
                    currency: this.store.currency,
                    value: Math.round(this.basket.price.balance * 100)
                };

                this.applePayComponent = this.adyenCheckout.create('applepay', {
                    amount: amount,
                    configuration: {
                        merchantDisplayName: "TEBEX.ORG",
                        merchantId: "000000000200147",
                        merchantIdentifier: "000000000200147",
                        merchantName: "TEBEX.ORG",
                        displayName: "TEBEX.ORG"
                    },
                    totalPriceLabel: "Tebex Purchase",
                    countryCode: "GB",
                    buttonColor: this.$store.state.app.store.darkMode ? 'white' : 'black',
                    buttonSizeMode: "fill",
                    onChange: (state) => {
                        if (state.isValid) {
                            this.cards = false;
                        }

                        state.data.debug = {
                            amount: amount
                        }

                        this.$store.commit('setPaymentMethodData', {
                            valid: state.isValid,
                            data: state.data
                        });

                        this.$root.$emit("ApplePayMethodSelected");
                    },
                    onAuthorized: async (resolve, reject, event) => {
                        resolve();
                    }
                });

                this.applePayComponent
                    .isAvailable()
                    .then(() => {
                        this.showApplepay = true;
                        this.applePayComponent.mount(this.$refs['applepay-container']);
                    })
                    .catch(e => {
                        console.log(e);
                        //Apple Pay is not available
                    });
            },
            mountGooglePay() {
                this.showGooglepay = false;

                if (this.googlePayComponent) {
                    this.googlePayComponent.unmount();
                }

                this.googlePayComponent = this.adyenCheckout.create("googlepay", {
                    environment: "PRODUCTION",
                    amount: {
                        currency: this.store.currency,
                        value: this.basket.price.balance * 100
                    },
                    configuration: {
                        gatewayMerchantId: this.customer.country == "US" ? "TebexUS" : "TebexCheckout",
                        merchantId: "BCR2DN4T52WIB3QE",
                        merchantName: "TEBEX.ORG"
                    },
                    countryCode: this.customer.country == "US" ? "US" : "GB",
                    buttonColor: this.$store.state.app.store.darkMode ? 'white' : 'black',
                    buttonSizeMode: "fill",

                    onChange: (gpaystate) => {
                        if (gpaystate.isValid) {
                            this.cards = false;
                        }
                        this.$store.commit('setPaymentMethodData', {
                            valid: gpaystate.isValid,
                            data: gpaystate.data
                        });

                        this.$root.$emit("GooglePayMethodSelected");

                    }
                });

                this.googlePayComponent
                    .isAvailable()
                    .then(() => {
                        this.showGooglepay = true;

                        this.googlePayComponent.mount(this.$refs['googlepay-container']);
                    })
                    .catch(e => {
                        console.log(e);
                        //Google Pay is not available
                    });
            }
        },
        computed: {
            ...mapState({
                isPaymentMethodUpdate: state => state.basket.isPaymentMethodUpdate,
            }),
            selectedMethod () {
                return this.$store.state.payment.selectedMethod;
            },
            basket () {
                return this.$store.state.basket;
            },
            store () {
                return this.$store.state.app.store;
            },
            customer () {
                return this.$store.state.customer;
            },
            requirePostalCode () {
                return this.loaded && (!this.customer.postal_code || this.isPaymentMethodUpdate);
            },
            evervaultStyles() {
                const base = {
                    label: {
                        color: "#666666",
                        "font-family": "Roboto",
                        marginBottom: '0.9rem'
                    },
                    ".field input": {
                        display: 'block',
                        width: '100%',
                        height: 'calc(1.5em + 1.7rem + 4px)',
                        padding: '.85rem 1.15rem',
                        fontSize: '.75rem',
                        fontWeight: '400',
                        lineHeight: '1.5',
                        color: '#495057',
                        backgroundColor: '#fff',
                        backgroundClip: 'padding-box',
                        border: '2px solid #f0f0f0',
                        borderRadius: '.25rem',
                        transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                    },
                    ".field input::placeholder": {
                        color: '#b2b2b2',
                    },
                    ".field input:focus": {
                        color: '#495057',
                        backgroundColor: '#fff',
                        borderColor: '#ddd',
                        outline: '0',
                        boxShadow: '0'
                    },
                }

                return merge(base, this.$store.state.app.store.darkMode ? {
                    label: {
                        color: "white",
                    },
                    ".field input": {
                        color: 'white',
                        backgroundColor: '#494949',
                        border: '1px solid #494949'
                    },
                    ".field input::placeholder": {
                        color: '#b2b2b2',
                    },
                    ".field input:focus": {
                        color: '#ffffff',
                        backgroundColor: '#494949',
                        borderColor: '#dddddd',
                        outline: '0',
                        boxShadow: '0px'
                    }
                } : {});
            }
        },
        async mounted() {
            const checkout = new AdyenCheckout({
                locale: this.$store.state.locale.selected,
                environment: window.tebex.methods.adyen.environment,
                originKey: window.tebex.methods.adyen.originKey,
                clientKey: window.tebex.methods.adyen.clientKey,
                paymentMethodsResponse: this.selectedMethod.fields.fields,
                onChange: this.handleCardOnChange,
                onBrand: this.handleOnBrand,
                onBinValue: (bin) => this.bin = bin.binValue,
                onConfigSuccess: () => this.loaded = true,
                styles: {
                    base: {
                        color: this.$store.state.app.store.darkMode ? 'white' : 'black',
                        fontSize: '0.75rem',
                        fontWeight: '400',
                        fontFamily: 'Roboto, sans-serif'
                    }
                }
            });

            this.adyenCheckout = await checkout;

            const evervault = new Evervault('team_0e5197190ac1', process.env.MIX_EVERVAULT_PROXY_ID);

            const theme = evervault.ui.themes.clean({
                fonts: [
                    "https://fonts.googleapis.com/css2?family=Roboto"
                ],
                styles: this.evervaultStyles,
            })

            const card = evervault.ui.card({
                theme: theme
            })
            card.on("change", payload => {
                if (payload.card.bin) {
                    this.bin = payload.card.bin;
                }

                if (payload.card.brand) {
                    this.handleOnBrand({'brand': payload.card.brand});
                }

                let cardState = {};
                cardState.data = {...payload.card};
                cardState.data.brand = null;
                cardState.isValid = payload.isValid & payload.isComplete;
                cardState.data.source = "evervault";
                cardState.data.paymentMethod = {'type':'scheme'}

                this.handleCardOnChange(cardState);
            })
            card.mount("#card-container")
            this.loaded = true;

            this.mountGooglePay();
            this.mountApplePay();

            if (this.customer.postal_code) {
                this.postalcode = this.customer.postal_code;
            }

            this.$store.commit('setPaymentMethodData', {
                valid: false,
                data: {}
            });
        },
        watch: {
            basket() {
                this.mountGooglePay();
                this.mountApplePay();
            }
        }
    }
</script>
